import { genericCreate } from '@/services/gql';

interface ReturnFields {
  id: string;
  src: string;
}

const create = genericCreate<ReturnFields>('asset', `id, src`);

export {
  create,
};
